import React from "react";

const ExportExcelButton = ({ onClick, label = "Export Excel", disabled = false }) => (
    <button
        type="button"
        className="export-excel-btn"
        onClick={onClick}
        disabled={disabled}
        aria-label={label}
    >
        <i className="fa fa-download export-excel-btn__icon" aria-hidden="true" />
        <span>{label}</span>
    </button>
);

export default ExportExcelButton;
